import React, { useState, useCallback } from "react";

const snackbarInitState = {
    open: false,
    message: '',
    severity: 'success',
    stayOpen: false,
};

const useSnackbar = () => {
    const [snackbar, setSnackbar] = useState(snackbarInitState);

    const show = useCallback((message, severity, stayOpen = false) => {
        setSnackbar({
            open: true,
            message,
            severity,
            stayOpen
        });
    }, []);

    const close = useCallback(() => {
        setSnackbar(snackbarInitState);
    }, []);

    return {
        ...snackbar,
        show,
        close
    };
};

export default useSnackbar;
